import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AnalysisData {
  id: string;
  measurement_date: string;
  name: string;
  distance: number;
  data: {
    speed?: number;
    pitch?: number;
    stride?: number;
    contactTime?: number;
    flightTime?: number;
    predicted100m?: number | string;
  };
  comment?: string;
  created_at: string;
  updated_at: string;
}

interface AnalysisState {
  results: AnalysisData[];
  isLoading: boolean;
  error: string | null;
  
  addResult: (data: Omit<AnalysisData, 'id' | 'created_at' | 'updated_at'>) => void;
  deleteResult: (id: string) => void;
  getResults: () => AnalysisData[];
}

export const useAnalysisStore = create<AnalysisState>()(
  persist(
    (set, get) => ({
      results: [],
      isLoading: false,
      error: null,

      addResult: (data) => {
        try {
          const newResult: AnalysisData = {
            id: crypto.randomUUID(),
            measurement_date: data.measurement_date,
            name: data.name,
            distance: data.distance,
            data: data.data || {},
            comment: data.comment,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          };

          set(state => ({
            results: [newResult, ...state.results],
            error: null
          }));
        } catch (err) {
          console.error('Error adding result:', err);
          set({ error: 'データの保存に失敗しました' });
        }
      },

      deleteResult: (id) => {
        try {
          set(state => ({
            results: state.results.filter(result => result.id !== id),
            error: null
          }));
        } catch (err) {
          console.error('Error deleting result:', err);
          set({ error: 'データの削除に失敗しました' });
        }
      },

      getResults: () => {
        return get().results;
      }
    }),
    {
      name: 'sprint-analysis-data',
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name);
          if (!str) return null;
          try {
            return JSON.parse(str);
          } catch {
            return null;
          }
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
      partialize: (state) => ({
        results: state.results
      })
    }
  )
);